import MainLayout from '@layouts/main';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import {
  JSXElementConstructor,
  ReactElement,
  useEffect,
  useState,
} from 'react';

const RouteGuard = (props: {
  children: ReactElement<unknown, string | JSXElementConstructor<unknown>>;
}) => {
  const { children } = props;
  const [moduleEnabled, setModuleEnabled] = useState(false);
  const router = useRouter();
  const { data: session, status } = useSession();

  useEffect(() => {
    const isAuthenticated = status === 'authenticated';

    if (router.asPath.includes('/403') || router.asPath.includes('/error')) {
      setModuleEnabled(true);
      return;
    }

    if (!isAuthenticated && !router.asPath.includes('/auth')) {
      return;
    }

    if (router.asPath.includes('/auth')) {
      setModuleEnabled(true);
      return;
    }

    if (isAuthenticated && router.asPath.includes('/support')) {
      setModuleEnabled(true);
      return;
    }

    const featureFlagCheck = () => {
      const hasFeature = (feature: string) =>
        session?.features.includes(feature);

      let enabled = false;

      if (hasFeature('maintenance-mode')) {
        if (router.asPath !== '/') router.push('/');
        setModuleEnabled(true);
        return;
      }

      enabled = true;

      // insert feature flag checks here

      if (!enabled && !router.asPath.includes('404')) {
        setModuleEnabled(false);
        if (router.asPath !== '/') router.push('/');
      } else {
        setModuleEnabled(true);
      }
    };

    featureFlagCheck();

    const preventAccess = () => setModuleEnabled(false);

    router.events.on('routeChangeStart', preventAccess);
    router.events.on('routeChangeComplete', featureFlagCheck);

    return () => {
      router.events.off('routeChangeStart', preventAccess);
      router.events.off('routeChangeComplete', featureFlagCheck);
    };
  }, [router, router.events, session?.features, status]);

  return moduleEnabled ? (
    children
  ) : (
    <MainLayout breadcrumb={undefined} panelled={false} showSpinner={true} />
  );
};

export default RouteGuard;
